/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { Paper } from "@material-ui/core";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};

const getItemStyle = (draggableStyle) => ({
	padding: "12px 0",
	...draggableStyle,
});

/**
 *
 * @param {Array} items objects to display in a draggable list, must have id property
 * @param {(items) => void} setItems function to call on drag end with a new item list
 * @param {() => React.element} renderItem function to render the UI for each item in the list
 */
export const DraggableList = ({ items, setItems, renderItem }) => {
	const onDragEnd = (result) => {
		// dropped outside the list
		if (!result.destination) {
			return;
		}

		const newItems = reorder(items, result.source.index, result.destination.index);
		setItems(newItems);
	};

	return (
		<DragDropContext onDragEnd={onDragEnd}>
			<Droppable droppableId="droppable">
				{(provided) => (
					<div {...provided.droppableProps} ref={provided.innerRef}>
						{items.map((item, index) => (
							<Draggable key={item.id} draggableId={item.id} index={index}>
								{(provided) => (
									<div
										ref={provided.innerRef}
										{...provided.draggableProps}
										style={getItemStyle(provided.draggableProps.style)}
									>
										<Paper elevation={0} variant="outlined" className="d-flex align-items-center p-2">
											<div style={{ marginRight: 10 }}>
												<i
													title="Drag to reorder"
													{...provided.dragHandleProps}
													className="fas fa-grip-vertical"
													style={{ color: "#E5E7EB", fontSize: 24 }}
												></i>
											</div>
											<div style={{ width: "100%" }}>{renderItem(item, index)}</div>
										</Paper>
									</div>
								)}
							</Draggable>
						))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
	);
};
